const orderHistoryAddProductsCollectData = products => {
	const reorderData = [...products]
		.map(collectAddProductData)
		.filter(data => !!data);
	return { cartEntries: reorderData };
};

const collectAddProductData = product => {
	const reorderCheckbox = product.querySelector('[data-product-add-checkbox]');
	if (reorderCheckbox.checked) {
		const sku = product.getAttribute('data-product');
		const quantity = product.querySelector('[data-quantity]').value;
		return { sku, quantity };
	}
	return null;
};

export default orderHistoryAddProductsCollectData;
